import { createSlice } from '@reduxjs/toolkit'
import { setIsClearingReduxFormState } from 'state/ui'

const initialState = {
  contact: {
    requiredDocuments: {
      licenseImage: {
        isTempFolder: false,
      },
      licenseImageBack: {
        isTempFolder: false,
      },
    },
  },
}

export const customerContactsSlice = createSlice({
  name: 'customerContacts',
  initialState,
  reducers: {
    clearContact: state => {
      state.contact = initialState.contact
    },
    saveRequiredDocumentsState: (state, action) => {
      state.contact.requiredDocuments = action.payload
    },
    setIsTempFolder: (state, action) => {
      const { fileNameKey } = action.payload
      state.contact.requiredDocuments[fileNameKey].isTempFolder = action.payload.isTemp
    },
  },
  extraReducers: builder => {
    builder.addCase(setIsClearingReduxFormState, (state, action) => {
      if (action.payload) {
        state.contact = initialState.contact
      }
    })
  },
})

export const { clearContact, saveRequiredDocumentsState, setIsTempFolder } = customerContactsSlice.actions

export default customerContactsSlice.reducer
